module.exports = __webpack_public_path__ + "static/img/mogos_phone3.00a5ece.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store/mogos_phone3.png
// module id = 661
// module chunks = 0